import { reactive } from 'vue';

export function useArrayRefComposable<arrayRefType = any>() {
    const templateRefs: Array<arrayRefType> = reactive([]);
    const refUids: Array<string> = reactive([]);

    function setTemplateRef(reference: any) {
        // reference wird null wenn Komponente unmounted wird
        if (reference === null || refUids.includes(reference?.$.uid)) {
            return;
        }
        templateRefs.push(reference);

        refUids.push(reference?.$.uid);
    }

    return {
        setTemplateRef,
        templateRefs: templateRefs,
    };
}
